import React from 'react';
import { importFromS3 } from '../../utils/importFromS3';
// eslint-disable-next-line camelcase
import { LEGACY_sendMessage } from '../../utils/legacy';
import { Operation } from '../../hooks/useOperations/types';

interface IProps {
  operationsSelected: Operation[],
  sendMessage: (msg: string) => void,
  shouldRenderFarmerNav: boolean
}

// Runtime dependency
const ReportsPlugin: React.FC<IProps> = React.lazy(() => importFromS3('tcc-reports-plugin'));

export const ReportsPluginContainer = ({ operationsSelected }: { operationsSelected: Operation[] }) => (
  <ReportsPlugin
    // eslint-disable-next-line camelcase
    sendMessage={LEGACY_sendMessage}
    operationsSelected={operationsSelected}
    shouldRenderFarmerNav={false}
  />
);
